export default __webpack_public_path__ + "static/media/Deepiq_chart (7).99c54b55.png";